export function getView(details) {
  return details?.id !== undefined
}
